/* eslint-disable max-len */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import {
  Paper,
  Accordion,
  AccordionSummary,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  TextField,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import DayPicker, { DateUtils } from 'react-day-picker';
import Switch from '@material-ui/core/Switch';
import Lightbox from 'react-image-lightbox';
import EnhancedTableHead from '../../../CommonComponents/TableComponents/EnhancedTableHead';
import {
  getComparator,
  stableSort,
} from '../../../CommonComponents/TableComponents/TableUtils';
import {
  CommonButton,
  CommonCarousel,
  CommonModal,
} from '../../../CommonComponents';
import SiteCarouselSlide from '../SiteCarouselSlide';
import {
  approveRejectSiteReport,
  createNewTask,
  getSiteReportsBySiteId,
  notifyMonitor,
  updateSiteLinkForReport,
} from '../../../redux/actions/sites';
import FallbackCard from '../../../CommonComponents/FallbackCard';
import 'react-image-lightbox/style.css';
import { showToast } from '../../../Utils';
import {
  finalImageUpload,
  uploadImageToSwagger,
} from '../../../APIServices/watermarkUploadService';
import SiteRapportAuditorRow from './SiteRapportAuditorRow';

const headCells = [
  {
    id: 'siteId',
    numeric: false,
    disablePadding: true,
    label: '',
  },
  {
    id: 'siteId',
    numeric: false,
    disablePadding: true,
    label: 'Site Id',
  },
  {
    id: 'startDate',
    numeric: false,
    disablePadding: true,
    label: 'Duration',
  },
  {
    id: 'mediaType',
    numeric: true,
    disablePadding: false,
    label: 'Media',
  },
  {
    id: 'monitor',
    numeric: true,
    disablePadding: false,
    label: 'Monitor',
  },
  {
    id: 'cityName',
    numeric: true,
    disablePadding: false,
    label: 'City',
  },
  {
    id: 'locationName',
    numeric: true,
    disablePadding: false,
    label: 'Location',
  },
  {
    id: 'supplierName',
    numeric: false,
    disablePadding: false,
    label: 'Supplier',
  },
  {
    id: 'frequency',
    numeric: false,
    disablePadding: false,
    label: 'Frequency',
  },
  {
    id: 'campaignNo',
    numeric: false,
    disablePadding: false,
    label: 'Campaign',
  },
  {
    id: 'progress',
    numeric: false,
    disablePadding: false,
    label: 'Progress',
  },
  {
    id: 'tasks',
    numeric: false,
    disablePadding: false,
    label: 'Tasks',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  right: {
    float: 'right',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    float: 'right',
    marginLeft: 20,
    width: 200,
  },
  searchBar: {
    float: 'right',
    width: '100%',
  },
  accordion: {
    boxShadow: 'none',
    display: 'block',
    padding: 0,
  },
  detailBtn: {
    marginLeft: 'auto',
    fontWeight: 'bold',
    marginTop: '4px',
  },
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: '#bdbdbd',
    justifyContent: 'center',
    alignContent: 'center',
    alignSelf: 'center',
  },
  cancel: {
    position: 'absolute',
    top: 5,
    right: 10,
    zIndex: 1,
    color: '#fff',
  },
  pointer: {
    cursor: 'pointer',
  },
  noImage: {
    backgroundColor: '#333333',
    textAlign: 'center',
  },
  CircularLoader: {
    position: 'fixed',
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    top: 0,
    backgroundColor: '#f5f5f578',
    left: 0,
    zIndex: 10000,
  },
}));

let disabledDates = [];

const SiteRapportAuditorTable = ({
  allSites,
  currentPageCount,
  createNTask,
  getSiteReports,
}) => {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('SiteId');
  const [page] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [siteToView, setSiteToView] = useState(null);
  const [site, setSite] = useState(null);
  const [carousels, setCarousels] = useState([]);
  const [lightbox, setLightbox] = useState([]);
  const [showLighBox, openLightBox] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [captureTime, setCaptureTime] = useState('');
  const [openModal, setOpenModal] = React.useState(null);
  const [dates, selectedDates] = useState([]);
  const [selected, setSelected] = useState([]);
  const [openWaterModel, setOpenWaterModel] = useState(false);
  const [openAlertModel, setOpenAlertModel] = useState(false);
  const [watermarkRowData] = useState(null);
  const [watermarkValData] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [finalUploadURL, setFinalUploadURL] = useState(null);
  const [coordinates, setCoordinates] = useState({
    latitude: '',
    longitude: '',
  });
  const [errors, setErrors] = useState({
    latitude: '',
    longitude: false,
  });
  const [watermarkTime, setWatermarkTime] = useState('');
  const [isFieldDisabled, setIsFieldDisabled] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const formattedTime = moment(watermarkTime, 'HH:mm').format('hh:mm A');

  const isUploaderDisabled = !coordinates.latitude || !coordinates.longitude || !watermarkTime;
  const isModelUploadDisabled = !coordinates.latitude
    || !coordinates.longitude
    || !watermarkTime
    || !selectedImage
    || !finalUploadURL;
  const downloadFileName = `watermarked-image-${Date.now()}.jpg`;
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleDismissModal = () => {
    setSiteToView({});
    setModalOpen(false);
  };

  const handleViewDetails = (row, val) => {
    setSite(val);
    setSiteToView(row);
    setCaptureTime(row.captureTime);
    const siteData = [];
    const lighboxArr = [];
    if (row) {
      if (row.img1) {
        siteData.push({ url: row.img1, type: 'image', status: row.status });
        lighboxArr.push(row.img1);
      }
      if (row.img2) {
        siteData.push({ url: row.img2, type: 'image', status: row.status });
        lighboxArr.push(row.img2);
      }
      if (row.img3) {
        siteData.push({ url: row.img3, type: 'image', status: row.status });
        lighboxArr.push(row.img3);
      }
      if (row.img4) {
        siteData.push({ url: row.img4, type: 'image', status: row.status });
        lighboxArr.push(row.img4);
      }
      if (row.videoUrl) {
        siteData.push({ url: row.videoUrl, type: 'video', status: row.status });
      }
      if (row.videoUrl1) {
        siteData.push({
          url: row.videoUrl1,
          type: 'video',
          status: row.status,
        });
      }
      if (row.type === 'default') {
        siteData.push({ url: row.imageUrl, type: 'image', status: '' });
        lighboxArr.push(row.imageUrl);
      }
      setCarousels(siteData);
      setLightbox(lighboxArr);
    }
    setModalOpen(true);
  };

  const getFrequency = (val) => {
    switch (val) {
      case 'Every15Days':
        return 'Every 15 days';
      case 'StartEndDate':
        return 'Start and end date';
      case 'CustomDate':
        return 'Custom Dates';
      default:
        return '';
    }
  };

  const openLighBoxModal = (index) => {
    setPhotoIndex(index);
    openLightBox(true);
  };

  const addTask = (id) => {
    const row = allSites.find((item) => item.id === id);
    if (row.site_reports) {
      const siteReports = row.site_reports;
      disabledDates = siteReports.map(
        (item) => new Date(
          moment(item.visitDate).format('YYYY'),
          moment(item.visitDate).format('MM') - 1,
          moment(item.visitDate).format('DD'),
        ),
      );
    }
    setOpenModal(row);
  };

  const createTask = () => {
    createNTask(openModal.id, dates);
    selectedDates([]);
    setOpenModal(null);
    disabledDates = [];
  };

  const handleDayClick = (day, { selectedItem, disabled }) => {
    if (disabled) {
      return;
    }
    const newdates = [...dates];
    if (selectedItem) {
      const selectedIndex = newdates.findIndex((selectedDay) => DateUtils.isSameDay(selectedDay, day));
      newdates.splice(selectedIndex, 1);
    } else {
      newdates.push(day);
    }
    selectedDates(newdates);
  };

  const handleLatitudeChange = (event) => {
    const { value } = event.target;

    // Updated regex to validate latitude input (-90 to 90)
    const regex = /^-?([0-9]{0,2})(\.\d{0,8})?$/;

    // Update the latitude in state
    setCoordinates((prevState) => ({
      ...prevState,
      latitude: value,
    }));

    // Validate the input as user types
    if (regex.test(value)) {
      const numValue = parseFloat(value);
      // Check if the latitude is in range (-90 to 90)
      if (numValue >= -90 && numValue <= 90) {
        setErrors((prevState) => ({
          ...prevState,
          latitude: false,
        }));
      } else {
        setErrors((prevState) => ({
          ...prevState,
          latitude: true,
        }));
      }
    } else {
      setErrors((prevState) => ({
        ...prevState,
        latitude: true,
      }));
    }
  };

  const handleLongitudeChange = (event) => {
    const { value } = event.target;

    // Updated regex to validate longitude input (-180 to 180)
    const regex = /^-?((1[0-7]?\d)|([1-9]?\d))(\.\d{0,8})?$/;

    // Update the longitude in state
    setCoordinates((prevState) => ({
      ...prevState,
      longitude: value,
    }));

    // Validate the input as user types
    if (regex.test(value)) {
      const numValue = parseFloat(value);
      // Check if the longitude is in range (-180 to 180)
      if (numValue >= -180 && numValue <= 180) {
        setErrors((prevState) => ({
          ...prevState,
          longitude: false,
        }));
      } else {
        setErrors((prevState) => ({
          ...prevState,
          longitude: true,
        }));
      }
    } else {
      setErrors((prevState) => ({
        ...prevState,
        longitude: true,
      }));
    }
  };

  const handleTimeChange = (event) => {
    setWatermarkTime(event.target.value);
  };

  const handleEditImage = () => {
    setSelectedImage('');
    setIsFieldDisabled(false);
  };

  // Function to reset form fields
  const resetFields = () => {
    setSelectedImage('');
    setWatermarkTime('');
    setIsFieldDisabled(false);
    setCoordinates({
      latitude: '',
      longitude: '',
    });
  };

  // Function to trigger image download
  const downloadImage = (imageUrl, filename) => {
    if (!imageUrl) return;
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFinalImageUpload = async () => {
    setIsLoading(true);
    console.log('[handleFinalImageUpload] Starting upload process...');

    try {
      // Ensure we have the required upload URL and watermark data
      if (!finalUploadURL || !watermarkRowData?.id) {
        const errorMsg = 'Invalid upload URL or watermark data!';
        console.error('[handleFinalImageUpload] Validation failed:', {
          hasFinalUploadURL: !!finalUploadURL,
          watermarkRowDataId: watermarkRowData?.id,
        });
        showToast('error', errorMsg);
        setIsLoading(false);
        return;
      }

      console.log('[handleFinalImageUpload] Step 1: Uploading image to Swagger...');
      // Upload image to Swagger API
      const uploadURL = await uploadImageToSwagger(
        finalUploadURL,
        watermarkRowData?.id,
      );
      
      if (!uploadURL?.path) {
        const errorMsg = 'Failed to upload image, missing upload URL path!';
        console.error('[handleFinalImageUpload] Upload response invalid:', uploadURL);
        showToast('error', errorMsg);
        setIsLoading(false);
        return;
      }

      console.log('[handleFinalImageUpload] Step 2: Image uploaded successfully, path:', uploadURL.path);

      // Ensure all required data is present before uploading final image
      if (
        !coordinates?.latitude
        || !coordinates?.longitude
        || !watermarkTime
        || !watermarkRowData?.visitDate
      ) {
        const errorMsg = 'Missing required data for final image upload!';
        console.error('[handleFinalImageUpload] Missing required fields:', {
          latitude: coordinates?.latitude,
          longitude: coordinates?.longitude,
          watermarkTime,
          visitDate: watermarkRowData?.visitDate,
        });
        showToast('error', errorMsg);
        setIsLoading(false);
        return;
      }

      // Prepare the final object to upload
      const finalObj = {
        img1: uploadURL.path,
        lat: coordinates.latitude,
        long: coordinates.longitude,
        time: watermarkTime,
        date: watermarkRowData.visitDate,
      };

      console.log('[handleFinalImageUpload] Step 3: Submitting final upload with data:', finalObj);

      // Upload the final image data using then/catch/finally
      finalImageUpload(finalObj, watermarkRowData?.id)
        .then((response) => {
          console.log('[handleFinalImageUpload] Final upload successful:', response?.data);
          if (response && response?.data?.message) {
            // Success handler
            setOpenWaterModel(false);
            resetFields();
            showToast('success', response?.data?.message);

            // Download the image after successful upload
            downloadImage(selectedImage, downloadFileName);
          }
        })
        .catch((error) => {
          // Error handler
          console.error('[handleFinalImageUpload] Final upload failed:', error);
          setOpenWaterModel(false);
          resetFields();
          
          // Show the actual error message from the API service
          const errorMessage = error.message || 'Site upload failed!';
          showToast('error', errorMessage);
          downloadImage(selectedImage, downloadFileName);
        })
        .finally(() => {
          setIsLoading(false); // Final cleanup
          if (watermarkRowData?.siteId) {
            getSiteReports(watermarkRowData?.siteId);
          }
        });
    } catch (error) {
      // Error handler for synchronous errors
      console.error('[handleFinalImageUpload] Unexpected error:', error);
      setOpenWaterModel(false);
      resetFields();
      setIsLoading(false);
      
      // Show the actual error message
      const errorMessage = error.message || 'Site uploaded failed!';
      showToast('error', errorMessage);
      downloadImage(selectedImage, downloadFileName);
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const img = new Image();
      img.src = reader.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Maintain original image size
        canvas.width = img.width;
        canvas.height = img.height;

        // Draw image on canvas
        ctx.drawImage(img, 0, 0, img.width, img.height);

        // Watermark text
        const timeText = `Time: ${moment(watermarkRowData?.visitDate).format(
          'MMMM DD, YYYY',
        )} ${formattedTime}, Latitude: ${coordinates.latitude}, Longitude: ${
          coordinates.longitude
        }`;
        const locationText = `Location: ${watermarkValData?.locationName}, ${watermarkValData?.cityName}, ${watermarkValData?.stateName}`;

        // Font settings
        const baseFontSize = 19; // Minimum font size
        const scaleFactor = 0.025; // Adjust this value for scaling
        let fontSize = Math.max(
          baseFontSize,
          Math.min(img.width, img.height) * scaleFactor,
        );
        if (img.width < 500 || (img.width > 500 && img.width < 1000)) {
          fontSize = 12;
        }
        if (fontSize > 19) {
          fontSize = 19;
        }
        ctx.font = `${fontSize}px "Noto Sans SemBd", sans-serif`;

        // Measure text width
        const textWidth = img.width;

        // Adjust font size if text is too wide
        while (textWidth > canvas.width && fontSize > 10) {
          fontSize -= 1;
          ctx.font = `${fontSize}px "Noto Sans", sans-serif`;
        }

        // Set text positioning
        const lineSpacing = 5; // Space between two lines
        const paddingAboveFirstLine = 3; // 3px padding above the first line
        const textHeight = fontSize;
        const totalTextHeight = textHeight * 2 + lineSpacing + paddingAboveFirstLine;

        // Draw background only behind text with exact height
        ctx.fillStyle = 'rgba(41, 175, 213, 1)'; // Blue background
        ctx.fillRect(
          0,
          img.height - totalTextHeight,
          textWidth,
          totalTextHeight,
        );

        // Draw text
        ctx.fillStyle = 'rgba(255, 255, 255, 1)'; // White text
        ctx.textAlign = 'left';
        ctx.textBaseline = 'top';

        // Draw first line (move it down by 3px)
        const textY = img.height - totalTextHeight + paddingAboveFirstLine;
        ctx.fillText(timeText, 0, textY);

        // Draw second line with 5px spacing
        ctx.fillText(locationText, 0, textY + textHeight + lineSpacing);

        // Convert canvas to image
        const watermarkedImageUrl = canvas.toDataURL('image/jpeg');
        if (watermarkedImageUrl) {
          setSelectedImage(watermarkedImageUrl);
          setIsFieldDisabled(true);

          // Convert to File object
          fetch(watermarkedImageUrl)
            .then((res) => res.blob())
            .then((blob) => {
              const fileData = new File(
                [blob],
                `watermarked-${Date.now()}.jpg`,
                {
                  type: 'image/jpeg',
                },
              );
              setFinalUploadURL(fileData);
            })
            .catch(() => {});
        }
      };
    };
  };

  const handleAlertModel = async () => {
    setOpenAlertModel(false);
    handleFinalImageUpload();
  };

  const helperTextStyles = makeStyles(() => ({
    error: {
      '&.MuiFormHelperText-root.Mui-error': {
        color: 'red',
      },
    },
  }));

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = allSites
        .filter((n) => n?.actionabletasks.some((item) => item.type === 'default')
        && n?.actionabletasks.some((item) => item.type === 'sd'))
        .map((obj) => obj.id);
      setSelected(newSelecteds);
    } else {
      setSelected([]);
    }
  };

  const handleSelect = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const user = JSON.parse(localStorage.getItem('user'));
  return (
    <div className={classes.root}>
      {allSites?.length > 0 ? (
        <div>
          <Paper className={classes.paper}>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  headCells={headCells}
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  rowCount={allSites.length}
                  numSelected={selected.length}
                  selected={selected.length > 0}
                  checkbox={false}
                />
                <TableBody>
                  {stableSort(allSites, getComparator(order, orderBy))
                    .slice(
                      page * currentPageCount,
                      page * currentPageCount + currentPageCount,
                    )
                    .map((row, index) => {
                      let dayText = '';
                      const frequencyText = getFrequency(row.frequency);
                      if (row.Duration > 1) {
                        dayText = 'Days';
                      }
                      if (row.Duration === 1) {
                        dayText = 'Day';
                      }
                      const firstName = row.monitor;
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <SiteRapportAuditorRow
                          key={row.id}
                          row={row}
                          labelId={labelId}
                          dayText={dayText}
                          vendorUser={`${firstName || ''}`}
                          frequencyText={frequencyText}
                          handleViewDetails={handleViewDetails}
                          addTask={addTask}
                          selected={isSelected(row.id)}
                          handleSelect={handleSelect}
                        />
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>
      ) : (
        <FallbackCard text="No data found" />
      )}
      {modalOpen && (
        <CommonModal
          open
          width="md"
          padded={false}
          onClose={() => {
            handleDismissModal();
          }}
          cancelButtonText="Reject"
          successButtonText="Approve"
          hideActionbuttons
        >
          <Card>
            {carousels.length > 0 ? (
              <CommonCarousel>
                {carousels.map((media, index) => (
                  <SiteCarouselSlide
                    index={index}
                    key={siteToView.id}
                    media={media}
                    approvedMedia={siteToView.approvedUrl}
                    openLightBox={openLighBoxModal}
                  />
                ))}
              </CommonCarousel>
            ) : (
              <CardContent className={classes.noImage}>
                <Typography style={{ color: '#fff', fontWeight: 'bold' }}>
                  No image found
                </Typography>
              </CardContent>
            )}
            <CardContent>
              <div className="row">
                <div className="col-6">
                  <div>
                    <b>Location :-</b>
                    {' '}
                    {site.locationName}
                    {', '}
                    {site.cityName}
                    {', '}
                    {site.stateName}
                  </div>
                  {siteToView?.type !== 'default' ? (
                    <>
                      <div>
                        <b>Vendor User :-</b>
                        {' '}
                        {site.monitor}
                      </div>
                      <div>
                        <b>Capturing Time :-</b>
                        {' '}
                        {captureTime}
                        {(user.userType === 'manager'
                          || user.userType === 'admin')
                        && siteToView.status === 'submitted' ? (
                          <Switch
                            checked={captureTime === 'Night'}
                            onChange={() => setCaptureTime(
                              captureTime === 'Night' ? 'Day' : 'Night',
                            )}
                            color="primary"
                            name="checkedA"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                          />
                          ) : null}
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <b>Latitude :-</b>
                        {' '}
                        {siteToView.latitude}
                      </div>
                      <div>
                        <b>Longitude :-</b>
                        {' '}
                        {siteToView.longitude}
                      </div>
                    </>
                  )}
                </div>
                {siteToView?.type !== 'default' ? (
                  <>
                    {/* <div className="col-6">
                      {(user.userType === 'manager' ||
                        user.userType === 'admin') &&
                      siteToView.status === 'submitted' ? (
                        <div className={classes.right}>
                          <Chip
                            className="m-2"
                            icon={<Done />}
                            label="Approve"
                            color="primary"
                            onClick={() => performAction('approved')}
                          />
                          <Chip
                            label="Reject"
                            color="secondary"
                            onClick={() => performAction('rejected')}
                            icon={<NotInterested />}
                          />
                        </div>
                      ) : null}
                      {(user.userType === 'manager' ||
                        user.userType === 'admin') &&
                      siteToView.status === 'approved' ? (
                        <>
                          {!site.onetED ? (
                            <div className={classes.right}>
                              <Chip
                                className="m-2"
                                label="Add as ED Link"
                                color="primary"
                                onClick={() =>
                                  addReportLinkToSite('ed', siteToView.id)
                                }
                              />
                            </div>
                          ) : null}
                          {!site.onetSD ? (
                            <div className={classes.right}>
                              <Chip
                                className="m-2"
                                label="Add as SD Link"
                                color="primary"
                                onClick={() =>
                                  addReportLinkToSite('sd', siteToView.id)
                                }
                              />
                            </div>
                          ) : null}
                        </>
                      ) : null}
                      {(user.userType === 'manager' ||
                        user.userType === 'admin') &&
                      siteToView.status === 'approved' &&
                      mediaUrl !== undefined &&
                      mediaUrl !== null &&
                      mediaUrl.type !== 'video' &&
                      siteToView.captureTime === 'Night' ? (
                        <div className={classes.right}>
                          <Chip
                            className="m-2"
                            label="Add as Night Photo Link"
                            color="primary"
                            onClick={() =>
                              addReportLinkToSite('night', siteToView.id)
                            }
                          />
                        </div>
                      ) : null}
                      {user.userType !== 'buyer' &&
                      user.userType !== 'creative' &&
                      siteToView.status === 'submitted' ? (
                        <>
                          <div className="clearfix" />
                          <div className={classes.right}>
                            <CommonButton
                              basic="true"
                              color="primary"
                              onClick={() => notify(siteToView.id)}
                            >
                              Notify to retake picture
                            </CommonButton>
                          </div>
                        </>
                      ) : null}
                    </div> */}

                    <div className="col-12" style={{ padding: 0 }}>
                      <Accordion className={classes.accordion}>
                        <AccordionSummary
                          expandIcon={<ExpandMore color="primary" />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <div className={classes.divider} />
                          <CommonButton
                            className={classes.detailBtn}
                            basic="true"
                            color="primary"
                          >
                            Details
                          </CommonButton>
                        </AccordionSummary>

                        <div className="row pl-2 pr-2">
                          <div className="col-5">
                            <b>Frequency :-</b>
                            {' '}
                            {getFrequency(site.frequency)}
                            <br />
                            <b>Media Type :-</b>
                            {' '}
                            {site.mediaTypeName}
                            <br />
                            <b>Assign Date :-</b>
                            {' '}
                            {moment(siteToView.visitDate).format('DD MMM YYYY')}
                            <br />
                            <b>Monitoring Date :-</b>
                            {' '}
                            {moment(siteToView.reportedTime)
                              .utc('5:30')
                              .format('DD MMM YYYY, h:mm:ss a')}
                            {siteToView.approvedDate ? (
                              <>
                                <br />
                                <b>
                                  {siteToView.status === 'approved'
                                    && 'Approved On :-'}
                                  {siteToView.status === 'rejected'
                                    && 'Rejected On :-'}
                                </b>
                                {' '}
                                {moment(siteToView.approvedDate)
                                  .utc('5:30')
                                  .format('DD MMM YYYY')}
                              </>
                            ) : null}
                            {siteToView.dashUser ? (
                              <>
                                <br />
                                <b>
                                  {siteToView.status === 'approved'
                                    && 'Approved By :-'}
                                  {siteToView.status === 'rejected'
                                    && 'Rejected By :-'}
                                </b>
                                {' '}
                                {siteToView.dashUser.full_name}
                              </>
                            ) : null}
                            <br />
                            <b>Latitude :-</b>
                            {' '}
                            {siteToView.lat}
                            <br />
                            <b>Longitude :-</b>
                            {' '}
                            {siteToView.long}
                          </div>
                          <div className="col-7">
                            <div>
                              <b>Vendor Remark :-</b>
                              {' '}
                              {siteToView.vendorRemark}
                            </div>
                            <div className="mt-2">
                              <b>Manager Remark :-</b>
                              {siteToView.managerRemark ?? '-'}
                            </div>
                          </div>
                        </div>
                      </Accordion>
                    </div>
                  </>
                ) : null}
              </div>
            </CardContent>
          </Card>
        </CommonModal>
      )}
      {showLighBox && lightbox.length > 0 && (
        <Lightbox
          mainSrc={lightbox[photoIndex]}
          nextSrc={lightbox[(photoIndex + 1) % lightbox.length]}
          prevSrc={
            lightbox[(photoIndex + lightbox.length - 1) % lightbox.length]
          }
          onMovePrevRequest={() => setPhotoIndex((photoIndex + lightbox.length - 1) % lightbox.length)}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % lightbox.length)}
          onCloseRequest={() => openLightBox(false)}
        />
      )}
      {openModal && (
        <CommonModal
          title="Assign a new task"
          open
          width="md"
          onYes={createTask}
          onClose={() => {
            setOpenModal(null);
            selectedDates([]);
            disabledDates = [];
          }}
          successButtonText="Assign"
          cancelButtonText="Cancel"
        >
          <DayPicker
            disabledDays={[
              ...disabledDates,
              {
                after: new Date(
                  moment(
                    openModal.newEndDate
                      ? openModal.newEndDate
                      : openModal.endDate,
                  ).format('YYYY'),
                  moment(
                    openModal.newEndDate
                      ? openModal.newEndDate
                      : openModal.endDate,
                  ).format('MM') - 1,
                  moment(
                    openModal.newEndDate
                      ? openModal.newEndDate
                      : openModal.endDate,
                  ).format('DD'),
                ),
                before: new Date(
                  moment(openModal.startDate).format('YYYY'),
                  moment(openModal.startDate).format('MM') - 1,
                  moment(openModal.startDate).format('DD'),
                ),
              },
            ]}
            selectedDays={dates}
            onDayClick={handleDayClick}
          />
        </CommonModal>
      )}
      {openWaterModel && (
        <CommonModal
          title="Create a watermark"
          open
          width="md"
          disableBackdropClick
          onYes={() => {
            setOpenAlertModel(true);
          }}
          saveBtnDisable={isModelUploadDisabled || isloading}
          onClose={() => {
            setOpenWaterModel(false);
            setSelectedImage('');
            setWatermarkTime('');

            setIsFieldDisabled(false);
            setCoordinates((prevState) => ({
              ...prevState,
              latitude: '',
            }));
            setCoordinates((prevState) => ({
              ...prevState,
              longitude: '',
            }));
          }}
          successButtonText="Upload"
          cancelButtonText="Cancel"
        >
          <>
            <div />
            {isloading ? (
              <div className={classes.CircularLoader}>
                <CircularProgress />
              </div>
            ) : null}
            {watermarkValData && (
              <p className="text-nowwrap">
                <b>Location:- </b>
                {`${watermarkValData?.locationName}, ${watermarkValData?.cityName}, ${watermarkValData?.stateName} `}
              </p>
            )}
            <div style={{ marginBottom: '12px' }} className="row">
              <div className="col-6">
                <TextField
                  value={coordinates.latitude}
                  onChange={handleLatitudeChange}
                  id="latitude"
                  label="Latitude"
                  variant="outlined"
                  error={errors.latitude}
                  helperText={
                    errors.latitude ? 'Please enter correct latitude' : ''
                  }
                  disabled={isFieldDisabled}
                  className={helperTextStyles.error}
                  FormHelperTextProps={{ sx: { color: 'red' } }}
                />
              </div>
              <div className="col-6">
                <TextField
                  value={coordinates.longitude}
                  onChange={handleLongitudeChange}
                  id="Longitude"
                  label="Longitude"
                  variant="outlined"
                  helperText={
                    errors.longitude ? 'Please enter correct longitude' : ''
                  }
                  error={errors.longitude}
                  className={helperTextStyles.error}
                  disabled={isFieldDisabled}
                  FormHelperTextProps={{ sx: { color: 'red' } }}
                />
              </div>
            </div>
            {watermarkRowData && (
              <p>
                <b> Date:- </b>
                {`${moment(watermarkRowData?.visitDate).format(
                  'MMMM, DD, YYYY',
                )} `}
              </p>
            )}
            <div style={{ marginBottom: '12px' }}>
              <TextField
                label="Select time"
                style={{ width: '100%' }}
                type="time"
                value={watermarkTime}
                disabled={isFieldDisabled}
                onChange={handleTimeChange}
                id="time"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 300, // 5 min steps
                }}
              />
            </div>

            {/* <canvas ref={canvasRef} style={{ display: 'none' }} /> */}
            {selectedImage ? (
              <>
                <div style={{ marginBottom: '12px' }}>
                  <img
                    src={selectedImage}
                    alt=""
                    sizes="100vw"
                    style={{ width: '100%', height: 'auto' }}
                  />
                </div>

                <CommonButton
                  onClick={() => {
                    handleEditImage();
                  }}
                  color="primary"
                >
                  <b>Edit</b>
                </CommonButton>
              </>
            ) : (
              <input
                id="default_size"
                type="file"
                accept="image/*"
                disabled={isUploaderDisabled}
                onChange={handleImageUpload}
              />
            )}
          </>
        </CommonModal>
      )}
      {openAlertModel && (
        <CommonModal
          title="Are you sure you want to upload this picture?"
          open
          width="xm"
          disableBackdropClick
          onYes={() => {
            handleAlertModel();
          }}
          onClose={() => {
            setOpenAlertModel(false);
          }}
          successButtonText="Yes"
          cancelButtonText="No"
        />
      )}
    </div>
  );
};

const mapState = (state) => ({
  allSites: state.sites.allSites,
  currentPageCount: state.sites.currentPageCount,
});

const mapActions = {
  approveRejectSite: approveRejectSiteReport,
  notify: notifyMonitor,
  updateSiteReportLink: updateSiteLinkForReport,
  createNTask: createNewTask,
  getSiteReports: getSiteReportsBySiteId,
};

export default connect(mapState, mapActions)(SiteRapportAuditorTable);
